import React, { useState } from 'react';
import { connect } from 'dva';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import {  FEATURE_TYPES } from '../../../../../lib/constants';
import { getColor } from '../../../../../lib/utils';
import actions from './actions'
import AreaIcon from '../../../../../assets/svg/AreaIcon';
import LineIcon from '../../../../../assets/svg/LineIcon';
import Search from '../../../../../assets/svg/Feather/Search';
import SelectSearch from 'react-select-search';
import styles from './FeatureSearch.module.scss';
import TracksIcon from '../../../../../assets/svg/TracksIcon';
import WaypointIcon from '../../../../../assets/svg/WaypointIcon';

function FeatureSearch(props) {
  const { featuresList } = props;

  // super simple search.
  let feature = null
  let searchMap = {};

  for (let fli = 0; fli < featuresList.length; fli++) {
    feature = featuresList[fli]
    const searchableQuery = feature.title.toLowerCase();
    const resultData = {
      title: feature.title,
      feature,
      key: feature.uuid,
      name: feature.uuid,
      value: feature.uuid,
    };
    if (!searchMap[searchableQuery]) {
      searchMap[searchableQuery] = [];
    }

    searchMap[searchableQuery].push(resultData);
  }

  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    const query = value.toLowerCase();

    let searchResults = [];
    if (query !== '') {
      for (let searchableQuery in searchMap) {
        if (searchableQuery.indexOf(query) !== -1) {
          searchResults.push(...searchMap[searchableQuery]);
        }
      }
    }

    setResults(searchResults);
  };

  const icon = (item) => {
    if (item && item.properties) {
      if (item.properties.ghType === FEATURE_TYPES.Polyline) {
        return <LineIcon width={16} color={getColor(item)} />;
      } else if (item.properties.ghType === FEATURE_TYPES.Polygon) {
        return <AreaIcon width={16} color={getColor(item)} />;
      } else if (item.properties.ghType === FEATURE_TYPES.Tracks) {
        return <TracksIcon width={16} color={getColor(item)} />;
      } else {
        return (
          <WaypointIcon
            icon={item.properties.icon}
            color={getColor(item)}
            width={16}
          />
        );
      }
    }
  };

  return (
    <div className={styles.searchBox}>
      <SelectSearch
        options={results}
        search
        onChange={props.handleResultSelect}
        renderValue={(valueProps) => {
          return (
            // <input  className='select-search__value-container' {...valueProps} value={query} onChange={handleSearchChange} />
            <div
              {...valueProps}
              className='select-search__value-container'
            >
              <div className='select-search__value-label'>
                <input value={query} onChange={handleSearchChange} placeholder='Search Content' />
              </div>
              <Search width={20} />
            </div>
          );
        }}
        renderOption={(optionsProps, optionData, optionSnapshot) => {
          return (
            <button
              {...optionsProps}
              className={`select-search__option ${styles.searchResultItem}`}
            >
              {icon(optionData.feature)}
              <div className={styles.resultDetail}>
                <div className={styles.resultTitle}>{optionData.title}</div>
                <div className={styles.resultSubtitle}>
                  {'Last updated: ' +
                    dayjs
                      .unix(
                        optionData.feature.properties &&
                          optionData.feature.properties.updatedAt
                          ? optionData.feature.properties.updatedAt
                          : dayjs().unix()
                      )
                      .format('MM/DD/YYYY')}
                </div>
              </div>
            </button>
          );
        }}
      />
    </div>
  );
}

FeatureSearch.propTypes = {
  featuresList: PropTypes.array,
  // actions
  handleResultSelect: PropTypes.func
};

export default connect((model) => ({
  featuresList: model.features.featuresList,
}), actions)(FeatureSearch);
